import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { convertRestIdToEwsId } from 'owa-identifiers';
import { isImmutableId } from 'owa-immutable-id-store';
import type { MailboxInfo } from 'owa-client-types';
import type { SubstrateSearchSuggestionsResponseEventSuggestion } from '../../data/schema/SubstrateSearchSuggestionsResponse';
import type { EventSuggestion } from '../../data/schema/SuggestionSet';
import { SuggestionKind } from '../../data/schema/SuggestionSet';

export default function convertSubstrateEventSuggestion(
    suggestion: SubstrateSearchSuggestionsResponseEventSuggestion,
    mailboxInfo: MailboxInfo
): EventSuggestion {
    return {
        kind: SuggestionKind.Event,
        Subject: suggestion.Subject,
        Text: suggestion.Text,
        EventId:
            isAccountFeatureEnabled('fwk-immutable-ids', mailboxInfo) &&
            isImmutableId(suggestion.ImmutableId)
                ? convertRestIdToEwsId(suggestion.ImmutableId)
                : suggestion.EventId.Id,
        ReferenceId: suggestion.ReferenceId,
        Start: suggestion.Start,
        End: suggestion.End,
        Location: suggestion.Location,
        OrganizerName: suggestion.OrganizerName,
        OrganizerAddress: suggestion.OrganizerAddress,
        OnlineMeetingUrl: suggestion.OnlineMeetingUrl,
        SkypeTeamsMeetingUrl: suggestion.SkypeTeamsMeetingUrl,
        IsAllDay: suggestion.IsAllDay,
        IsCancelled: suggestion.IsCancelled,
    };
}
